var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagGl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(30 11)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -11)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.5 14.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    transform: "translate(-5 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6H18l-.158,9.765h-18L-5.89,6ZM3,6A4,4,0,1,0,7,2,4,4,0,0,0,3,6",
    fill: "#d00c33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGl);
export default __webpack_public_path__ + "static/media/flagGL.ded2d2ac4300c14f9744d2c7af45705d.svg";
export { ForwardRef as ReactComponent };